import React from 'react'

const FullPageLoader = () => {
    return (
        <div className="center-body-loader">
            <div className="loader-triangle-9">
                <div></div>
                <div></div>
            </div>
        </div>
    )
}

export default FullPageLoader